<template>
  <div class="container-fluid px-4 py-4 legal-page">

    <!-- Header estilo panel -->
    <div class="legal-header mb-4">
      <button class="btn-volver mb-3" @click="$router.back()">
        <i class="fas fa-arrow-left"></i> Volver
      </button>
      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3">
        <div>
          <h4 class="mb-1">Política de Cookies</h4>
          <p class="mb-0 text-muted">
            Información sobre el uso de cookies y tecnologías similares, así como la forma de gestionar tu consentimiento.
          </p>
        </div>

        <div class="legal-meta">
          <div class="meta-title">Última actualización</div>
          <div class="meta-value">{{ lastUpdate }}</div>
        </div>
      </div>
    </div>

    <!-- Card principal -->
    <div class="card legal-card">
      <div class="card-body">

        <div class="soft-note mb-4">
          <b>Resumen:</b> las cookies necesarias están siempre activas. El resto solo se activan si las aceptas.
          Puedes modificar tu elección en cualquier momento desde el banner de cookies (si aparece) o ajustando el consentimiento desde tu navegador.
        </div>

        <h5 class="mt-3">1. ¿Qué son las cookies?</h5>
        <p>
          Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar un sitio web.
          Permiten recordar información de navegación (por ejemplo, sesión o preferencias) y mejorar la experiencia.
          Algunas cookies son <b>propias</b> (gestionadas por este sitio) y otras pueden ser de <b>terceros</b> (proveedores externos).
        </p>

        <h5 class="mt-4">2. Tipos de cookies</h5>
        <p class="mb-3">
          Este sitio puede utilizar las siguientes categorías. Las cookies no necesarias solo se activan con tu consentimiento.
        </p>

        <div class="table-responsive mb-3">
          <table class="table table-sm cookie-table">
            <thead>
              <tr>
                <th style="width: 240px;">Categoría</th>
                <th>Finalidad</th>
                <th style="width: 170px;">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Técnicas / Necesarias</b></td>
                <td>Funcionamiento básico, seguridad, navegación, sesión y carga de recursos.</td>
                <td><span class="badge bg-success">Siempre activas</span></td>
              </tr>
              <tr>
                <td><b>Preferencias</b></td>
                <td>Recuerdan ajustes (por ejemplo, idioma o configuración de interfaz).</td>
                <td><span class="badge bg-secondary">Opcionales</span></td>
              </tr>
              <tr>
                <td><b>Analíticas</b></td>
                <td>Medición agregada del uso del sitio para mejorar rendimiento y contenidos.</td>
                <td><span class="badge bg-secondary">Opcionales</span></td>
              </tr>
              <tr>
                <td><b>Marketing</b></td>
                <td>Personalización de contenidos o publicidad (si procede).</td>
                <td><span class="badge bg-secondary">Opcionales</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="text-muted small mb-4">
          El listado exacto de cookies puede variar en función de las herramientas activas (analítica, embeds, integraciones).
          Esta política se actualizará cuando se incorporen o sustituyan servicios.
        </p>

        <h5 class="mt-4">3. Cookies de terceros</h5>
        <p>
          Algunos servicios de terceros (por ejemplo, analítica web, vídeos embebidos o integraciones) pueden instalar cookies.
          En ese caso, se mostrarán como categorías configurables en el banner o panel de configuración para que puedas aceptarlas o rechazarlas.
        </p>
          <h6 class="mt-3">3.1. Herramientas actualmente utilizadas</h6>
          <div class="table-responsive mb-3">
            <table class="table table-sm cookie-table">
              <thead>
                <tr>
                  <th style="width:220px;">Servicio</th>
                  <th>Finalidad</th>
                  <th style="width:180px;">Categoría</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>Google Tag Manager (GTM)</b></td>
                  <td>Gestión de etiquetas. No activa medición si no aceptas categorías no necesarias.</td>
                  <td><span class="badge bg-secondary">Analíticas/Marketing (según tags)</span></td>
                </tr>
                <tr>
                  <td><b>Google Analytics 4 (GA4)</b></td>
                  <td>Medición agregada de uso para mejorar el producto.</td>
                  <td><span class="badge bg-secondary">Analíticas</span></td>
                </tr>
              </tbody>
            </table>
          </div>

          <p class="text-muted small mb-4">
            Nota: esta lista puede ampliarse o modificarse cuando se integren nuevos servicios. En ese caso, se actualizará esta política.
          </p>
        <h5 class="mt-4">4. Base legal</h5>
        <p>
          El uso de cookies técnicas/ necesarias se basa en la necesidad de prestar el servicio y permitir el correcto funcionamiento del sitio.
          El uso de cookies de preferencias, analíticas y marketing se basa en tu <b>consentimiento</b>, que puedes otorgar o retirar en cualquier momento.
        </p>

        <h5 class="mt-4">5. Cómo cambiar o retirar tu consentimiento</h5>
        <p class="mb-2">
          Puedes modificar tu elección en cualquier momento desde el banner de cookies o desde el boton de Preferencias en la barra inferior.
          También puedes borrar o bloquear cookies desde tu navegador.
        </p>
          <h6 class="mt-3">Cómo guardamos tu elección</h6>
          <p class="mb-4">
            Tu selección se almacena localmente en tu navegador (por ejemplo, en <b>localStorage</b>) para recordar tus preferencias.
            Además, si usas servicios de Google, se aplica el modo de consentimiento mediante <b>gtag('consent','update', ...)</b>,
            activando o desactivando medición y publicidad según tus elecciones.
          </p>

        <h5 class="mt-4" id="navegadores">6. Gestionar cookies desde el navegador</h5>
        <p>
          La mayoría de navegadores permiten bloquear o eliminar cookies. Ten en cuenta que si bloqueas cookies necesarias,
          algunas funciones pueden no estar disponibles.
        </p>

        <ul class="mb-4">
          <li><b>Chrome:</b> Configuración → Privacidad y seguridad → Cookies y otros datos</li>
          <li><b>Firefox:</b> Ajustes → Privacidad y seguridad → Cookies y datos del sitio</li>
          <li><b>Safari:</b> Preferencias → Privacidad</li>
          <li><b>Edge:</b> Configuración → Cookies y permisos del sitio</li>
        </ul>
        <h5 class="mt-4">7. Plazos de conservación</h5>
        <p class="mb-0">
          Algunas cookies son de sesión (se eliminan al cerrar el navegador) y otras son persistentes (se eliminan automáticamente tras un tiempo).
          Los plazos pueden variar según el proveedor y la configuración vigente en cada momento.
        </p>

        <h5 class="mt-4">8. Actualizaciones</h5>
        <p class="mb-0">
          Esta política puede actualizarse por cambios legislativos o técnicos. Se recomienda revisarla periódicamente.
        </p>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PoliticaCookies",
  beforeMount() {
    this.$store.commit('setShowSidenav', false);
    this.$store.commit('setShowNavbar', true);
    this.$store.commit('setShowFooter', true);
  },
  data() {
    return {
      lastUpdate: process.env.VUE_APP_COOKIES_LAST_UPDATE || new Date().toLocaleDateString("es-ES"),
    };
  },
};
</script>

<style scoped>
.legal-card{
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0,0,0,.06);
  border: 1px solid var(--q-border);
}

.legal-header{
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 14px;
  padding: 16px 18px;
}

.legal-meta{
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 10px 12px;
  min-width: 220px;
}

.meta-title{ font-size: .75rem; opacity: .75; }
.meta-value{ font-weight: 800; }

.soft-note{
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--q-amber-soft);
  border: 1px solid var(--q-gold);
}

.cookie-table{
  border-radius: 12px;
  overflow: hidden;
  margin: 0;
}
.cookie-table thead th{
  font-size: .82rem;
  opacity: .85;
  border-bottom: 1px solid var(--q-border);
}
.cookie-table td{
  vertical-align: top;
  border-bottom: 1px solid var(--q-border);
}
.cookie-table tbody tr:last-child td{
  border-bottom: 0;
}

.btn-volver {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--q-border-md);
  color: var(--q-muted);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: .85rem;
  cursor: pointer;
  transition: color .15s, border-color .15s;
}
.btn-volver:hover { color: var(--q-text); border-color: var(--q-gold); }
</style>
